import actions from '../../actionTypes';

export default tag => {
  return {
    type: actions.ADDED_TAG,
    tag
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/addedTag.js